'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
require('react');
require('../../../../../../node_modules/@fortawesome/react-fontawesome/index.es.cjs');
require('@emotion/react');
require('aviary-tokens');
require('../../internal/InternalSkeleton/InternalSkeleton.web.styles.cjs');
require('../Typography/Typography.web.cjs');
var InternalButtonLink_web = require('../../internal/InternalButtonLink/InternalButtonLink.web.cjs');
var Skeleton_web = require('../Skeleton/Skeleton.web.cjs');
var Button_web_styles = require('./Button.web.styles.cjs');

/**
 * A styled component used as a trigger to perform a specific action. Unambiguously communicates what action will occur when the button is clicked.
 *
 * @scope: Core
 */ const Button = ({ variant = "primary", intention, size = "medium", isLoading = false, children, customCss, ...rest })=>{
    const buttonStyles = [
        Button_web_styles.base,
        Button_web_styles.variant[variant],
        intention === "danger" && Button_web_styles.intention.danger,
        intention === "inverted" && Button_web_styles.intention.inverted[variant],
        Button_web_styles.size[size],
        customCss
    ];
    if (isLoading) {
        return /*#__PURE__*/ jsxRuntime.jsx(Skeleton_web.Skeleton, {
            type: "button",
            size: size
        });
    }
    return /*#__PURE__*/ jsxRuntime.jsx(InternalButtonLink_web.InternalButtonLink, {
        css: buttonStyles,
        ...rest,
        children: children
    });
};

exports.Button = Button;
//# sourceMappingURL=Button.web.cjs.map
